import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const PlusIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 23, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 23) / 23}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.7632 9.76316H13.2368V2.23684C13.2368 1.27911 12.4577 0.5 11.5 0.5C10.5423 0.5 9.76316 1.27911 9.76316 2.23684V9.76316H2.23684C1.27911 9.76316 0.5 10.5423 0.5 11.5C0.5 12.4577 1.27911 13.2368 2.23684 13.2368H9.76316V20.7632C9.76316 21.7209 10.5423 22.5 11.5 22.5C12.4577 22.5 13.2368 21.7209 13.2368 20.7632V13.2368H20.7632C21.7209 13.2368 22.5 12.4577 22.5 11.5C22.5 10.5423 21.7209 9.76316 20.7632 9.76316Z"
        fill="currentColor"
      />
    </svg>
  )
})

PlusIcon.displayName = 'PlusIcon'
